import styled from 'styled-components';
import Button from '../button/Button';

export const StyledIconButton = styled(Button)`
    background-color: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
    width: max-content;
    height: max-content;
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        color: var(--brand-6);

        &:hover {
            color: var(--brand-5);
        }
    }

    &:focus-visible {
        outline: 1px solid var(--gray-10) !important;
    }

    &:active {
        box-shadow: transparent;
    }

    &:disabled {
        cursor: not-allowed;
        svg {
            color: var(--gray-7);
        }
    }
`;
